module.exports = {"title":"Account Creation","content":"Please create a password or link a social media account.","password":"Password","confirmPassword":"Confirm your Password","submit":"Submit","passwordsNotTheSame":"The passwords are not the same","useSocial":"Link your social media account","useSocialContent":"If you chose to link your social media account, you will always need to log in using this account.","loginGoogle":"Login with Google","msg":{"yay":"Yay!","oops":"Oops!","success":"Your account has been confirmed."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/NewUserLogin/locales/en.json
// module id = 1770
// module chunks = 0